import { createPromiseResolver, isMobile, getHoustonCollector } from '@sbt-web/utils';
import { Tracker } from '@scm-italy/pulse-sdk-js';

const COLLECTOR_URL = 'https://collector.mpianalytics.com';
const COLLECTOR_PATH = 'api/v1/track';
const CIS_BASE_URL = 'https://cis.mpianalytics.com';
const CONF = {
    // override default values. Get it from Houston collector:
    collectorBaseUrl: COLLECTOR_URL,
    cisBaseUrl: CIS_BASE_URL,
    collectorPath: COLLECTOR_PATH,
    eventDebounce: 200,
    environment: 'browser',
    useBeaconWhenAvailable: true,
};
const [promiseTracker, resolveTracker] = createPromiseResolver();
let neverResolved = true;
class Pulse {
    isReady;
    constructor(env, userId) {
        const [initializedPromise, resolveInitialized] = createPromiseResolver();
        this.isReady = initializedPromise;
        this.initTracker(resolveInitialized, env, userId); //NOSONAR
    }
    /**
     * When demerge will be completed, please mark env as mandatory
     */
    async initTracker(resolveInitialized, env, userId) {
        const tracker = await this.initPulseInstance();
        // Set userId:
        const backCompatibilityUserId = userId ?? window.subito?.dataLayer?.user?.id;
        if (backCompatibilityUserId) {
            this.setActor(backCompatibilityUserId);
        }
        // set deploy stage and product type:
        if (env) {
            this.setEnv(env);
        }
        tracker.update({ provider: { productType: isMobile() ? 'M-Site' : 'Web' } }, true // This is needed to tell the SDK not to overwrite the existing object but to merge it
        );
        resolveInitialized(true);
    }
    async initPulseInstance() {
        if (neverResolved) {
            neverResolved = false;
            try {
                // Always use the Houston collector in prod:
                const collector = await getHoustonCollector('prod');
                // Remove trailing slash from collector URL:
                CONF.collectorBaseUrl = (collector.datacollector ?? '').replace(/\/$/, '');
            }
            catch {
                console.warn('Houston collector not found, using default');
            }
            // Define tracker:
            const tracker = new Tracker('subito', CONF, {});
            if (window?.subito) {
                window.subito.tracker = tracker;
            }
            resolveTracker(tracker);
        }
        return await promiseTracker;
    }
    async setActor(userId) {
        (await promiseTracker).update({
            actor: {
                '@type': 'Account',
                id: userId,
                realm: 'subito.it',
            },
        });
    }
    async setEnv(deployStageSubito) {
        const deployStage = normalizeEnvName(deployStageSubito);
        if (deployStage) {
            (await promiseTracker).update({ deployStage });
            return deployStage;
        }
        return null;
    }
    async getEnvironmentId() {
        return (await promiseTracker).getEnvironmentId();
    }
    async queueEvent(data, action = 'trackerEvent') {
        const tracker = await promiseTracker;
        if (data.type === 'View') {
            tracker.newPageView();
        }
        tracker.track(action, data).catch((e) => {
            console.warn('Pulse: The tracking failed with', e);
            return e;
        });
    }
    async getTracker() {
        return await promiseTracker;
    }
}
function normalizeEnvName(envName) {
    switch (envName) {
        case 'prod':
        case 'pro':
            return 'pro';
        case 'pre':
        case 'stage':
        case 'integration':
            return 'pre';
        case 'dev':
        case 'regress':
            return 'dev';
        default:
            return null;
    }
}

export { Pulse };
//# sourceMappingURL=client.js.map
